<template>
    <div class="email-selection-container">
        <p class="main-title">Enter Recipient information</p>
        <p class="main-subtitle small">Ship in bulk to many people or just one. Enter their email address below or fill out the email address template for bulk shipments.</p>
        <div class="first-container">
            <div class="product-container">
                <div class="gift-container selected" >
                    <img class="green-check" src="https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"/>
                    <img class="main-image lazyload" :src="product | getProductImage">
                    <div v-if="isBox" class="item-box">
                        <img class="box-image" src="https://cdn.shopify.com/s/files/1/1363/8433/files/emptybox_1.png?v=1659452617">
                        <div class="addon-images">
                            <img class="addon-image" v-for="image in boxImages" :key="image" :src="image"/>
                        </div>
                    </div>
                    <img v-else class="main-image lazyload" :src="product | getProductImage">
                    <p>{{ product.title }}</p>
                </div>
            </div>
            <div class="input-qty-container">
                <p class="title">Enter Number of Recipients</p>
                <div class="qty-selector">
                    <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/personicon.svg?v=1674850316"/>
                    <input min="1" @change="validateQty" v-model="emailQty" type="number">
                </div>
                <button @click="submitEmailQty" v-if="!didSubmit" class="happybox-button yellow">Continue</button>
            </div>
        </div>
        <div class="email-container" v-if="didSubmit">
            <div class="single-email-container" v-if="emailQty == 1">
                <!-- <p class="main-subtitle">After entering your recipient information below, you'll be able to customize their notification email. <br class="desktop"/> if you're gifting on behalf of someone, be sure to enter their name in the "From" section!</p> -->
                <div class="email-inputs-container">
                    <div class="input-container">
                        <p>Email</p>
                        <input v-model="emailAddress" placeholder="Enter single email address" type="email"/>
                    </div>
                    <div class="input-container">
                        <p>First Name</p>
                        <input v-model="emailFirstName" placeholder="Enter recipient first name" type="string"/>
                    </div>
                    <div class="input-container">
                        <p>Last Name</p>
                        <input v-model="emailLastName" placeholder="Enter recipient last name" type="string"/>
                    </div>
                    <div class="input-container">
                        <p>From</p>
                        <input v-model="emailFrom" placeholder="Enter sender name" type="string"/>
                    </div>
                </div>
            </div>
            <div class="multiple-email-container" v-else>
                <p class="main-subtitle small">Download our Bulk Recipient Email Template to upload your recipients. Don't worry, you only need their email address! </p>
                <div class="file-upload-container">
                    <input class="file-uploader" type="file" accept=".csv,.xlsx,.xls,.xlsb" @change="fileChange" />
                </div>
                <a class="download-template" href="https://cdn.shopify.com/s/files/1/1363/8433/files/Happy_Box_GOC_Recipient_Email_Address_Template.xlsx?v=1683313367" target="_blank">Download our recipient email bulk template</a>
            </div>
            <button :disabled="isValidEmail == false" @click="nextStep" class="happybox-button yellow">Continue</button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as XLSX from "xlsx"
import * as LZString from "lz-string"
export default {
    data(){
        return{
            emailQty: 1,
            didSubmit: true,
            emailAddress: "",
            emailFile: null,
            emailFirstName: "",
            emailLastName: "",
            emailFrom: "",
        }
    },
    props:{
        product: Object,
    },
    computed:{
        collectionPrice(){
            return parseInt(this.product.variants[0].price)
        },
        isValidEmail(){
        if(this.emailQty == 1){
            let validEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(this.emailAddress)
            return validEmail && this.emailFirstName != "" && this.emailLastName != "";
        }
        else {
            return this.emailFile != null;
        }
        },
        isBox(){
            return this.product.properties._gs_bundle_ids ? true : false
        },
        boxImages(){
            if(this.isBox)
                return this.product.properties.productImages
            else 
                return this.product.image
        },
    },
    methods:{
        submitEmailQty(){
            this.didSubmit = true;
        },
        nextStep(){
            let jsonData = null;
            if(this.emailQty == 1){
                jsonData = JSON.stringify([{firstName:this.emailFirstName,lastName: this.emailLastName,email:this.emailAddress,from:this.emailFrom}]);
                this.emailFile = LZString.compressToUTF16(jsonData);
            }
            this.$emit("next",{data:JSON.parse(jsonData), compressedData: this.emailFile, emailqty: this.emailQty})
        },
        fileChange(event){
            this.file = event.target.files ? event.target.files[0] : null;
            if (this.file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                /* Parse data */
                const bstr = e.target.result;
                const wb = XLSX.read(bstr, { type: 'binary' });
                /* Get first worksheet */
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                /* Convert array of arrays */
                this.skipHeaders(ws);
                const data = XLSX.utils.sheet_to_json(ws,{header: ["firstName","lastName", "email","date" ,"from"], skipHeader: true});
                this.readXlsAddresses(data);
                }

                reader.readAsBinaryString(this.file);
            }
        },
        skipHeaders(ws){
            var range = XLSX.utils.decode_range(ws['!ref']);
            range.s.r = 1; // <-- zero-indexed, so setting to 1 will skip row 0
            ws['!ref'] = XLSX.utils.encode_range(range);
        },
        readXlsAddresses(data){
            let file = data.map((x) => {
                x.notificationDate = this.excelDateToJSDate(x.date)
                return x
            });
            let jsonData = JSON.stringify(file);
            let compressedData = LZString.compressToUTF16(jsonData);
            this.emailQty = data.length;
            this.emailFile = compressedData;
            if(file.length == 1){
                this.emailAddress = data.email;
                this.emailName = data.name;
            }
        },
        validateQty(){
            if(this.emailQty < 1){
                this.emailQty = 1;
            }
        },
        excelDateToJSDate(serial){
            return this.removeTime(new Date(Date.UTC(0, 0, serial)));
        },
        removeTime(date = new Date()) {
            return new Date(
                date.getFullYear(),
                date.getMonth(),
                date.getDate()
            );
        },
    }

}
</script>

<style scoped>

.mobile{
    display: none;
}
.email-selection-page{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.email-selection-container{
    padding: 0% 10%;
}

.main-title{
    font-family: "moret",sans-serif;
    font-size: 2.5vw;
    margin: unset;
    line-height: 1.4;
    text-align: left;
    color: #0f0c38;
    font-weight: 300;
    width: 100%;
    text-align: center;
}

.main-subtitle{
    font-family: "karla",sans-serif;
    font-size: 1vw;
    margin: unset;
    line-height: 1.2;
    text-align: left;
    color: #0f0c38;
    text-align: center;
}

.footer-copy{
    font-family: "karla";
    font-size: 1vw;
    line-height: 1.2;
    text-align: center;
    color: #0f0c38;
}

.happybox-button.orange{
    padding: 1% 10%;
    margin: 3% 0%;
  }
  

  .download-template{
    border-radius: 30px;
    background: #F7F9FD;
    padding: 1% 3%;
    color: #0f0c38;
    font-size: 1.15vw;
    line-height: 1.2;
    text-decoration: underline;
  }

  .email-container{
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 3%;
    border-top: 0.5px solid gray;
  }

  .email-container button{
    margin: 3% 0%;
  }

  .multiple-email-container .main-subtitle{
    text-align: center;
    width: 100%;
  }

  .multiple-email-container{
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    margin-top: 3%;
  }

  .qty-selector{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2%;
    gap: 10px;
  }

  .qty-selector img{
    width: 10%;
  }

  .qty-selector input{
    width: 30%;
    height: 2.1em !important;
    min-height: 2.1em;
  }

  .file-upload-container{
    font-size: 1.2vw;
    color: #0f0c38;
  }

  .file-uploader{
    height: unset !important;
    border: unset !important;
    margin: unset;
    padding: 1% 0% !important;
    font-size: 1.2vw;
    color: #0f0c38;
    width: 70%;
  }

  .email-inputs-container{  
    margin-top: 3%;
    display: flex;
    width: 100%;
    gap: 15px;
  }

  .input-container{
    width: 23%;
  }

  .input-container p{
    font-weight: bold;
    font-size: 1.4vw;
    line-height: 1.6;
    margin: 0;
    color: #0f0c38;
  }

  .input-container input{
    width: 100%;
  }

  .first-container{
    width: 100%;
    display: flex;
    padding-top: 5%;
  }

  .first-container .product-container{
    width: 30%;
    margin-left: 10%;
  }

  .input-qty-container{
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .input-qty-container .title{
    font-size: 1.5vw;
    color: #0f0c38;
    margin-bottom: 0;
  }

    .image-container{
        position: relative;
    }

    .image-container .title-container{
        position: absolute;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        top: 40%;
    }

    .image-container .title-container .subtitle{
        font-size: 1.5vw;
        font-family: 'moret',sans-serif;
        line-height: 1;
    }

    .image-container .title-container .title{
        font-size: 1.15vw;
        line-height: 1;
        font-weight: bold;
    }

    .image-container img{
        width: 100%;
        border-radius: 20px;
        border: 1px solid gray;
    }

    .gift-container{
        width: 100%;
        margin-right: 2%;
        margin-bottom: 5%;
        border-radius: 4px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .gift-container.selected{
        border: 1px solid #16A34A;
    }

    .gift-container p {
        font-size: 1.1vw;
        font-weight: 700;
        padding-top: 5%;
    }

    .green-check{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }

    .gift-container .main-image{
        width: 100%;
        box-sizing: border-box;
        cursor: pointer;
        position: relative;
    }

    .item-box{
    width: 100%;
    position: relative;
    display: flex;
  }

  .item-box .box-image{
    width: 100%;
  }

  .item-box .addon-images{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
    padding: 10%;
    overflow: hidden;
  }

  .item-box .addon-images .addon-image{
    width: 25%;
    max-width: 50%;
    flex: 0 1 auto;
  }

  .addon-image:first-child:nth-last-child(1) {
    width: auto;
    max-width: 100%;
    max-height: 100%;
  }

  .addon-image:first-child:nth-last-child(2),
  .addon-image:first-child:nth-last-child(2) ~ .addon-image {
    width: auto;
    max-width: 50%;
    max-height: 100%
  }

  .addon-image:first-child:nth-last-child(3),
  .addon-image:first-child:nth-last-child(3) ~ .addon-image {
    width: auto;
    height: 50%;
  }

  .addon-image:first-child:nth-last-child(4),
  .addon-image:first-child:nth-last-child(4) ~ .addon-image {
    width: auto;
    height: 50%;
  }

  .addon-image:first-child:nth-last-child(5),
  .addon-image:first-child:nth-last-child(5) ~ .addon-image {
    width: auto;
    max-width: 33%;
    max-height: 50%;
  }

  .addon-image:first-child:nth-last-child(6),
  .addon-image:first-child:nth-last-child(6) ~ .addon-image {
    width: auto;
    max-width: 33%;
    max-height: 50%;
  }

  @media only screen and (max-device-width: 767px){

    .desktop{
        display: none;
    }

    .mobile{
        display: block;
    }
    .email-selection-page{
        min-height: 60vh;
    }

    .main-title{
        font-size: 8vw;
        width: 100%;
        line-height: 1.2;
    }

    .main-title span{
        font-style: italic;
    }

    .main-subtitle,.footer-copy{
        font-size: 3.5vw;
        margin: 4% 0%;
        padding: 0% 5%;
        line-height: 1.4;
    }

    .main-subtitle.small{
        width: 100%;
        text-align: center;
    }

    .first-container{
        flex-direction: column;
        align-items: center;
    }

    .first-container .product-container{
        margin: unset;
        width: 50%;
    }

    .input-qty-container .title{
        font-size: 3vw;
    }

    .recipients-container{
        margin-bottom: 10%;
    }

    .preview-container .recipient-title{
        font-size: 3.5vw;
    }

    .shipped-table th,.shipped-table tbody{
        font-size: 3vw;
    }
    

    .happybox-button.orange{
        margin: 7% 0%;
        width: 80%;
        padding: 2% 0%;
    }

    .download-template{
        text-decoration: underline;
        font-size: 3vw;
        padding: 2% 5%;
    }

    .file-uploader{
        font-size: 4vw;
        width: 80%;
    }

    .email-inputs-container{  
        flex-wrap: wrap;
        padding: 0% 5%;
        justify-content: space-between;
    }

    .input-container{
        width: 47%;
    }

    .input-container p{
        font-size: 3vw;
    }
  }

</style>